import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
//import './Modal.css';
import "./Hub.css";

function Cron() {
	const qs = require("qs");
	const navigate = useNavigate();

	const [data, setData] = useState([]);
	const [vendorData, setVendorData] = useState([]);

	const [currentPage, setCurrentPage] = useState(1);
	const [postsPerPage, setPostsPerPage] = useState(100);

	const indexOfLastPost = currentPage * postsPerPage;
	const indexOfFirstPost = indexOfLastPost - postsPerPage;

	const logout = () => {
		localStorage.removeItem("token");
		navigate("/");
	};

	const goPage = (path) => {
		navigate(path);
	};

	const handleChange = (event) => {
		const form = document.querySelector("form");
		const prog = form.querySelector("input[name=prog]:checked").value;
		if (prog === "spread") {
			form.querySelector("input[prog-type=spread]").checked = true;
			form.querySelectorAll("input[prog-type=glean]").forEach((input) => {
				if (input.checked) input.checked = false;
				input.disabled = true;
			});
			form.querySelectorAll("input[prog-type=spread]").forEach((input) => {
				input.disabled = false;
			});
			form.querySelectorAll("tr[prog-type=glean]").forEach((input) => {
				if (input.checked) input.checked = false;
				input.hidden = true;
			});
			form.querySelectorAll("tr[prog-type=spread]").forEach((input) => {
				input.hidden = false;
			});
		} else {
			form.querySelector("input[prog-type=glean]").checked = true;
			form.querySelectorAll("input[prog-type=spread]").forEach((input) => {
				if (input.checked) input.checked = false;
				input.disabled = true;
			});
			form.querySelectorAll("input[prog-type=glean]").forEach((input) => {
				input.disabled = false;
			});
			form.querySelectorAll("tr[prog-type=spread]").forEach((input) => {
				if (input.checked) input.checked = false;
				input.hidden = true;
			});
			form.querySelectorAll("tr[prog-type=glean]").forEach((input) => {
				input.hidden = false;
			});
		}
	};

	const makeCron = (e) => {
		e.preventDefault();
		const form = document.querySelector("form");
		const schedule = form.querySelector("input[name=schedule]").value;
		const prog = form.querySelector("input[name=prog]:checked").value;
		const mode = form.querySelector("input[name=mode]:checked").value;
		const type = form.querySelector("input[name=type]:checked").value;
		const arg = {};
		if (prog === "glean") {
			arg["vendorName"] = form.querySelector(
				"input[name=vendor]:checked"
			).value;
		} else {
			arg["marketId"] = form.querySelector("input[name=marketId]").value;
			arg["marketCode"] = form.querySelector(
				"input[name=marketCode]:checked"
			).value;
		}
		const data = {
			token: localStorage.getItem("token"),
			schedule,
			data: {
				type,
				prog,
				mode,
				arg,
			},
		};
		axios.post(
			`${window.location.protocol}//${window.location.hostname}:3012/make`,
			qs.stringify(data)
		);
		window.location.reload();
	};

	const delCron = (idx) => {
		axios.post(
			`${window.location.protocol}//${window.location.hostname}:3012/delete`,
			qs.stringify({
				token: localStorage.getItem("token"),
				idx,
			})
		);
		window.location.reload();
	};

	// 페이지 렌더링 후 가장 처음 호출되는 함수
	useEffect(
		() => {
			if (!localStorage.getItem("token")) navigate("/login");
			else {
				axios
					.post(
						`${window.location.protocol}//${window.location.hostname}:3001/check`,
						qs.stringify({
							token: localStorage.getItem("token"),
						})
					)
					.then((res) => {
						if (res.data.expired) {
							localStorage.removeItem("token");
							goPage("/login");
						}
					})
					.catch();

				axios
					.post(
						`${window.location.protocol}//${window.location.hostname}:3001/getCron`,
						qs.stringify({
							token: localStorage.getItem("token"),
						})
					)
					.then((res) => {
						setData(res.data.cronInfo || []);
						setVendorData(res.data.vendorInfo || []);
					})
					.catch();
			}
		},
		// 페이지 호출 후 처음 한번만 호출될 수 있도록 [] 추가
		[]
	);

	const parseArg = (arg) => {
		let pa = "";
		const content = JSON.parse(arg);
		for (const row in content) {
			pa += " " + content[row];
		}
		return pa;
	};

	const paginate = (pageNumber) => setCurrentPage(pageNumber);
	const pageNumbers = [];
	const totalPosts = data.length;
	for (let i = 1; i < Math.ceil(totalPosts / postsPerPage); i++) {
		pageNumbers.push(i);
	}

	return (
		<>
			<form onSubmit={(e) => makeCron(e)}>
				<table>
					<tbody>
						<tr>
							<th>스케쥴</th>
							<td>
								<input type="text" name="schedule"></input>
							</td>
						</tr>
						<tr>
							<th>프로그램</th>
							<td>
								<input
									type="radio"
									name="prog"
									value="glean"
									onChange={handleChange}
									defaultChecked
								/>
								글린
								<input
									type="radio"
									name="prog"
									value="spread"
									onChange={handleChange}
								/>
								스프레드
							</td>
						</tr>
						<tr>
							<th>모드</th>
							<td>
								<input
									type="radio"
									name="mode"
									value="sync"
									prog-type="glean"
									defaultChecked
								/>
								상품수집
								<input
									type="radio"
									name="mode"
									value="order"
									prog-type="glean"
								/>
								자동발주
								<input
									type="radio"
									name="mode"
									value="delivery"
									prog-type="glean"
								/>
								송장수집
								<input
									type="radio"
									name="mode"
									value="collect"
									prog-type="spread"
									disabled
								/>
								주문수집
								<input
									type="radio"
									name="mode"
									value="update"
									prog-type="spread"
									disabled
								/>
								상품갱신
								<input
									type="radio"
									name="mode"
									value="soldout"
									prog-type="spread"
									disabled
								/>
								품절처리
							</td>
						</tr>
						<tr prog-type="glean">
							<th>내용</th>
							<td>
								{vendorData.map((item, index) => (
									<>
										<input
											type="radio"
											name="vendor"
											value={item.vendorName}
											defaultChecked={!!!index}
										></input>
										<label for="vendor">{item.vendorName}</label>
									</>
								))}
							</td>
						</tr>
						<tr prog-type="spread" hidden>
							<th>내용</th>
							<td>
								마켓아이디: <input type="text" name="marketId"></input>
								<input
									type="radio"
									name="marketCode"
									value="smartstore"
									defaultChecked
								></input>
								<label for="vendor">smartstore</label>
							</td>
						</tr>
						<tr>
							<th>타입</th>
							<td>
								<input
									type="radio"
									name="type"
									value="regularly"
									checked={true}
								/>
								반복
								<input type="radio" name="type" value="one-off" />
								일회
							</td>
						</tr>
					</tbody>
				</table>
				<button type="submit">생성</button>
			</form>
			<div align="center">
				<table>
					<thead>
						<tr>
							<th>스케쥴</th>
							<th>프로그램</th>
							<th>모드</th>
							<th>내용</th>
							<th>타입</th>
							<th>삭제</th>
						</tr>
					</thead>
					<tbody>
						{data.slice(indexOfFirstPost, indexOfLastPost).map((item) => (
							<tr key={item.idx}>
								<td>{item.schedule}</td>
								<td>{item.prog}</td>
								<td>{item.mode}</td>
								<td>{parseArg(item.arg)}</td>
								<td>{item.type}</td>
								<td>
									<button onClick={() => delCron(item.idx)}>삭제</button>
								</td>
							</tr>
						))}
					</tbody>
				</table>
				<nav>
					<ul className="pagination">
						{pageNumbers.map((number) => (
							<li
								key={number}
								className={`page-item ${
									currentPage === number ? "active" : ""
								}`}
							>
								<button onClick={() => paginate(number)}>{number}</button>
							</li>
						))}
					</ul>
				</nav>
			</div>
		</>
	);
}

export default Cron;
